export default class DarkMode {
  constructor(holder) {
    if (!holder) {
      return
    }

    this.holder = holder
    this.input = holder.querySelector('.js-switch-input')
    this.body = document.querySelector('body')
    this.cookie = 'dark-mode'

    this.attachEvents()
  }

  attachEvents() {
    this.toggleClass()

  }

  setCookie(name, value) {
    document.cookie = name + '=' + value + '; Path=/;'
  }

  deleteCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
  }

  getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
    ))
    return matches ? decodeURIComponent(matches[1]) : undefined
  }

  toggleClass() {
    this.input.addEventListener('change', () => {
      if (this.input.checked === true) {
        this.addActiveClass()
        this.setCookie(this.cookie, true)
      } else {
        this.removeActiveClass()
        this.deleteCookie(this.cookie)
      }
    })
  }

  addActiveClass() {
    this.body.classList.add(this.cookie)
  }

  removeActiveClass() {
    this.body.classList.remove(this.cookie)
  }
}
